import React from 'react';

import { Route, Switch } from "react-router-dom";

export const RouteWithSubRoutes = (route) => {
  return (
    <Route
      path={route.path}
      exact={route.exact}
      render={(props) => (
        <>
          {route.component && (
            <route.component {...props} routes={route.routes} />
          )}
          {route.routes && route.routes.length > 0 && (
            <Switch>
              {/*the duplicate component created in sidebar becasue of this */}
              {/* {route.routes.map((subroute) => (
                <RouteWithSubRoutes key={subroute.path} {...subroute} />
              ))} */}
            </Switch>
          )}
        </>
      )}
    />
  );
};
